module.exports = {
  PouchAdapter: require('./pouch-adapter'),
  PGAdapter: require('./pg-adapter'),
  EntityApi: require('./entity-api'),
  ProxifiedEntityApi: require('./proxified-entity-api'),
  RestAdapter: require('./rest-adapter'),
  Logger: require('./logger')
}
